<html>

    <body class="dx-viewport">

        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        >
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="3.0"
            >
                <dx-box
                    direction="col"
                    width="100%"
                    height="100%"
                >
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="6"
                    >
                        
                        <dx-data-grid
                            #grideventinviteegift
                            id="grideventinviteegift"

                            keyExpr="id"
                            [dataSource]="subscriptioninviteelist"

                            [allowColumnReordering]="false"
                            [allowColumnResizing]="true"
                            [showRowLines]="true"
                            [showColumnLines]="false"
                            [showBorders]="true"
                            [repaintChangesOnly]="true"

                            [focusedRowEnabled]="true"
                            [hoverStateEnabled]="true"
                            [autoNavigateToFocusedRow]="true"

                            width="98%"
                            height="98%"

                        >
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxo-row-dragging
                                data="subscriptioninviteelist"

                                group="tasks"

                                [showDragIcons]="true"
                                [allowDropInsideItem]="true"

                                [onAdd]="onAdd"
                                [onDragStart]="onDragStartInviteeName"

                                dragTemplate="myDragTemplate"
                            >

                            <div *dxTemplate="let e of 'myDragTemplate'">
                                {{ e.itemData.firstname}}&nbsp;{{ e.itemData.lastname}}
                            </div>

                            </dxo-row-dragging>
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxo-filter-row
                                [visible]="true"
                            ></dxo-filter-row>
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxo-sorting
                                mode="single"> <!-- or "multiple" | "none" -->
                            </dxo-sorting>

                            <dxo-selection
                                mode="single"
                            >
                            </dxo-selection>

                            <dxo-load-panel
                                [enabled]="false">
                            </dxo-load-panel>

                            <dxo-editing
                                mode="cell"
                                [allowUpdating]="false"
                                [allowDeleting]="false"
                                [allowAdding]="false"
                                [useIcons]="false"
                            >
                            </dxo-editing>
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxi-column
                                dataField="id"
                                caption="id"
                                [allowEditing]="false"
                                [allowSorting]="false"
                                [visible]="false"
                                width="19%"
                            >

                            </dxi-column>

                            <dxi-column
                                dataField="whoseparticipant"
                                caption="Whose Guest"
                                [allowEditing]="false"
                                [allowSorting]="false"
                                [allowFiltering]="false"
                                [visible]="true"
                                width="19%"

                                groupCellTemplate="cellparticipantname"
                                [groupIndex]="0"

                            >

                                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                                <div *dxTemplate="let d of 'cellparticipantname'">
                                    <div>{{whoseguest | getinitial: d.value: whoseguest.length: 10 }}</div>
                                </div>
                                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->

                            </dxi-column>

                            <dxi-column
                                dataField="title"
                                caption="Title"
                                [allowEditing]="false"
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >

                            </dxi-column>

                            <dxi-column
                                dataField="lastname"
                                caption="Last Name"
                                [allowEditing]="false"
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >
                            </dxi-column>

                            <dxi-column
                                dataField="firstname"
                                caption="First Name"
                                [allowEditing]="false"
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >
                            </dxi-column>


                        </dx-data-grid>

                        
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->

                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="0.05"
                    >
                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="3"
                    >

                        <dx-data-grid 
                            #grideventgift
                            id="grideventgift"

                            keyExpr="id"
                            [dataSource]="subscriptiongiftlist"    

                            [allowColumnReordering]="false"
                            [allowColumnResizing]="true"
                            [showRowLines]="true"
                            [showColumnLines]="false"
                            [showBorders]="true"
                            [repaintChangesOnly]="true"

                            [focusedRowEnabled]="true"
                            [hoverStateEnabled]="true"
                            [autoNavigateToFocusedRow]="true"

                            width="98%"
                            height="98%"

                        >
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxo-filter-row
                                [visible]="true"
                            >
                            </dxo-filter-row>
                
                            <dxo-sorting
                                mode="single"> <!-- or "multiple" | "none" -->
                            </dxo-sorting>

                            <dxo-selection
                                mode="single"
                            >
                            </dxo-selection>

                            <dxo-load-panel
                                [enabled]="false">
                            </dxo-load-panel>

                            <dxo-editing 
                                mode="popup"                            
                                [allowUpdating]="false"
                                [allowDeleting]="false"
                                [allowAdding]="false"
                                [useIcons]="true"
                            >
                            </dxo-editing>
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxi-column
                                dataField="id"
                                caption="id"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="false"
                                width="19%"
                            >
                            </dxi-column>   

                            <dxi-column
                                dataField="giftdescription"
                                caption="Gift Description"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="50%"
                            >
                            </dxi-column>   

                            <dxi-column
                                dataField="giftlist"
                                caption="Gift Register"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="25%"

                                cellTemplate="cellStatusGiftRegister"
                            >

                                <div *dxTemplate="let data of 'cellStatusGiftRegister'">

                                    <container-element [ngSwitch]="data.value">
                                        <div *ngSwitchCase="true"><i class="fa-solid fa-circle-check fa-2x center"></i></div>
                                        <div *ngSwitchCase="false"><i class="fa-solid fa-circle-xmark fa-2x center"></i></div>
                                    </container-element>
                                    
                                </div>

                            </dxi-column>   

                            <dxi-column
                                dataField="giftassign"
                                caption="Gift Thankyou"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="25%"

                                cellTemplate="cellStatusGiftThankyou"
                            >


                                <div *dxTemplate="let data of 'cellStatusGiftThankyou'">

                                    <container-element [ngSwitch]="data.value">
                                        <div *ngSwitchCase="true"><i class="fa-solid fa-circle-check fa-2x center"></i></div>
                                        <div *ngSwitchCase="false"><i class="fa-solid fa-circle-xmark fa-2x center"></i></div>
                                    </container-element>
                                    
                                </div>


                            </dxi-column>   
            
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        </dx-data-grid>

                    </dxi-item>

                    

                </dx-box>

            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="0.005"
            >
            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="7.0"
            >
                 <!----------------------------------------------------------------------------------------------->
                 <div>
                    <dx-button
                        text="Add Thankyou Register for Gift Received"
                        stylingMode="contained"

                        type="normal"
                        width="100%"

                        (onClick)="onClickNewThankyouList($event)"
                    >
                    </dx-button>
                </div>
                <!----------------------------------------------------------------------------------------------->
                <dx-scroll-view
                    #scrollView
                    id="scrollview"

                    width="100%"
                    height="98%"

                    direction="both"
                    [scrollByContent]="true"

                    showScrollbar="always"
                    [useNative]="false"
                    reachBottomText="Updating..."
                >
                     <!----------------------------------------------------------------------------------------------->
                     <dx-tile-view
                        id="giftthankyouregister"
                        #giftthankyouregister
                        [dataSource]="subscriptiongiftthankyoulist"

                        [baseItemHeight]="250"
                        [baseItemWidth]="160"

                        width="100%"
                        height="100%"

                        [hoverStateEnabled] = "true"

                        [itemMargin]="15"

                        direction="vertical"

                        itemTemplate="list-item"
                    >

                        <div *dxTemplate="let data of 'list-item'; let index = index;">
                            <!----------------------------------------------------------------------------------------------->
                                <dx-box
                                    direction="col"
                                    width="100%"
                                    height="100%"
                                >

                                    <!----------------------------------------------------------------------------------------------->
                                    <dxi-item
                                        [ratio]="1.5"
                                        class="rectanglecard1"
                                    >
                                        <img [src]="" [id]="'tileview' + data.id" />
                                        
                                        <div>

                                            <dx-button
                                                id="tileViewButton"

                                                stylingMode="contained"
                                                type="normal"

                                                text={{data.giftrecieved}}
                                                [hint]='giftrecieved'

                                                (onClick)="onGiftSelectClicked(data)"
                                                (mouseover)="btngiftmouseover(data)"

                                                width="150"
                                                height="80%"
                                            >
                                            </dx-button>

                                        </div>


                                    </dxi-item>
                                    <!----------------------------------------------------------------------------------------------->
                                    <dxi-item
                                        [ratio]="1.5"
                                        class="rectanglecard1"
                                    >
                                        <div>

                                            <dx-button
                                                id="tileViewButton"
                                                
                                                stylingMode="contained"
                                                type="normal"

                                                text='Gift Reset'
                                                hint='Gift Reset'

                                                (onClick)="onGiftResetClicked(data)"

                                                width="150"
                                                height="85%"

                                            >
                                            </dx-button>

                                        </div>

                                    </dxi-item>
                                    <!----------------------------------------------------------------------------------------------->
                                    <dxi-item
                                        [ratio]="1.5"
                                        class="rectanglecard1"
                                    >
                                        <div>

                                            <dx-button
                                                id="tileViewButton"
                                                
                                                stylingMode="contained"
                                                type="normal"

                                                text={{data.deliverylist}}
                                                [hint]="deliverylist"

                                                (onClick)="onDeliveryClicked(data)"
                                                (mouseover)="btngiftdeliverymouseover(data)"

                                                width="150"
                                                height="80%"

                                            >
                                            </dx-button>

                                        </div>

                                    </dxi-item>
                                    <!----------------------------------------------------------------------------------------------->
                                    <dxi-item
                                        [ratio]="6"
                                        class="rectanglecard1"
                                    >
                                        <dx-list
                                            #thankyoulist
                                            id="thankyoulist"

                                            [items]="data.inviteename"

                                            height="98%"

                                            [allowItemDeleting]="true"
                                            itemDeleteMode="toggle"
                                            (onItemDeleted)="inviteeonItemDeleted($event, data.inviteename)"

                                        >

                                            <!----------------------------------------------------------------------------------------------->
                                            <dxo-item-dragging
                                                group="tasks"

                                                [data]="data.inviteename"

                                                [allowReordering]="false"

                                                [onDragStart]="onDragStart"
                                                [onDragEnd]="onDragEnd"

                                                [onAdd]="onAdd"

                                                dragTemplate="myDragTemplate1"
                                            >

                                                <div *dxTemplate="let e of 'myDragTemplate1'">
                                                    {{dragitem_inviteename}}
                                                </div>

                                            </dxo-item-dragging>
                                            <!----------------------------------------------------------------------------------------------->

                                            <div *dxTemplate="let item of 'item'">
                                                <div>{{item | extractinviteename:10 }}</div>
                                            </div>
                                            <!----------------------------------------------------------------------------------------------->


                                        </dx-list>

                                    </dxi-item>
                                    <!----------------------------------------------------------------------------------------------->
                                </dx-box>
                            <!----------------------------------------------------------------------------------------------->
                        </div>


                    </dx-tile-view>

                </dx-scroll-view>
                <!----------------------------------------------------------------------------------------------->
            </dxi-item>
             <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        </dx-box>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            [width]="300"
            [height]="180"
            [showTitle]="true"
            title="Selection"
            [dragEnabled]="true"
            [hideOnOutsideClick]="true"
            [showCloseButton]="true"

            [(visible)]="popupVisible"
        >

            <dxo-position
                my="left top"

                [of]="positionOf"

            >
                <div *dxTemplate="let data of 'content'">

                    <dx-list
                        #deliverylist
                        id="deliverylist"

                        [items]="invitedeliverylist"

                        height="98%"

                        (onItemClick)="onItemClick_invitedelivery( $event, listinvitationid )"

                    >

                        

                    </dx-list>

                </div>

            </dxo-position>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        
        </dx-popup>
    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    <dx-popup
        [width]="300"
        [height]="180"
        [showTitle]="true"
        title="Selection"
        [dragEnabled]="true"
        [hideOnOutsideClick]="true"
        [showCloseButton]="true"

        [(visible)]="popupGiftVisible"
    >

        <dxo-position
            my="left top"

            [of]="positionOf"

        >
            <div *dxTemplate="let data of 'content'">

                <dx-list
                    #giftlisting
                    id="giftlisting"

                    [items]="giftlist"

                    height="98%"

                    (onItemClick)="onItemClick_gift( $event, listgiftid )"
                >
                     <!----------------------------------------------------------------------------------------------->
                     <div *dxTemplate="let item of 'item'">

                        <div>{{item | extractinviteename:15 }}</div> 
                    
                    </div>
                    <!----------------------------------------------------------------------------------------------->
                </dx-list>

            </div>

        </dxo-position>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->

    </dx-popup>
    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>

</html>

